// Single place to lazy-load TalkJS and reuse one Session across the app.
let talkImportPromise: Promise<any> | null = null;
let talkSession: any | null = null;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export async function loadTalk() {
  if (!talkImportPromise) {
    talkImportPromise = import('talkjs').then((m) => m.default ?? m);
  }
  const Talk = await talkImportPromise;
  await Talk.ready;
  return Talk;
}

/**
 * Create or reuse a TalkJS session.
 * Accepts a plain "me" object; constructs Talk.User internally.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export async function getOrCreateSession(
  mePlain: {
    id: string;
    name: string;
    email?: string;
    welcomeMessage?: string;
    photoUrl?: string;
    role?: string;
  },
  appId: string
) {
  const Talk = await loadTalk();

  if (!talkSession) {
    const me = new Talk.User(mePlain);
    talkSession = new Talk.Session({ appId, me });
  }

  return { Talk, session: talkSession };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function destroySession() {
  if (talkSession) {
    try { talkSession.destroy(); } catch {}
    talkSession = null;
  }
}